// extracted by mini-css-extract-plugin
export default {"noData":"NoDataMessage-noData-b684"};